






























































import { Component, Prop } from "vue-property-decorator";
import { CompanyModel, FileDownloadModel } from "@/core/models";
import { QuestionnaireService, CompanyService } from "@/core/services";
import { ClientSkillsConsultantUpdateCpt } from "./";

import AppVue from "@/AppVue.vue";

@Component({
  components: {
    ClientSkillsConsultantUpdateCpt,
  },
})
export default class WorkshopClientHeaderCpt extends AppVue {
  @Prop() model: CompanyModel;
  @Prop({ default: false }) loading: boolean;
  @Prop({ default: true }) showActions: boolean;

  downloadingReport = false;

  private async downloadFollowUpReport() {
    this.downloadingReport = true;
    try {
      await CompanyService.downloadFollowUpReport(this.model.id);
    } finally {
      this.downloadingReport = false;
    }
  }

  private skillsConsultantUpdated() {
    this.$emit("company-updated");
  }

  private async downloadCriticalSkillsReport() {
    this.downloadingReport = true;
    try {
      const response: FileDownloadModel = await QuestionnaireService.downloadCriticalSkillsReportForCompany(
        this.model.id,
      );
      await QuestionnaireService.generateCriticalSkillsFile(response);
    } finally {
      this.downloadingReport = false;
    }
  }
}
